import React from "react";

const NotFound = () => {
  return <div className="" > 
  <h1 style={{width:"100vw",margin:"25vh 0" }} className="text-[#1976d2] text-center">  Image not found . . .
</h1>
   </div>;
}

export default NotFound;
